
$(document).ready(function() {

  $('.single-faq').click(function(){
    $(this).toggleClass('active');
  });

  $('#menu-button').click(function(){
    $('#flyout-nav').addClass('active');
  })


  $('#now-playing-feed').eocjsNewsticker({
    speed: 25
  });

   // Smooth scrolling to anchor links
  $('a[href^="#"]').on('click', function(event) {
    event.preventDefault();
    var target = $(this.hash);
      if (target.length) {
        $('html, body').animate({
        scrollTop: target.offset().top
        }, 1000);
      }
  });


  $('#flyout-nav .close').click(function(){
    $('#flyout-nav').removeClass('active');
  });

});
